import { Plus, Trash2 } from "lucide-react";
import { Input } from "../ui/input";

const UNIT_HINT = { half_pan: "per half pan", person: "per person", each: "per each" };

export const ComponentsEditor = ({ comps, basis, onChange }) => {
  const set = (i, k, v) => onChange(comps.map((c, j) => (j === i ? { ...c, [k]: v } : c)));
  return (
    <div data-testid="recipe-components" className="space-y-2">
      <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-brand-charcoal/60">
        What goes in (kitchen ticket checklist) · amounts {UNIT_HINT[basis]}
      </p>
      {comps.map((c, i) => (
        <div key={i} className="grid grid-cols-12 gap-2" data-testid={`recipe-component-${i}`}>
          <Input value={c.name} onChange={(e) => set(i, "name", e.target.value)} placeholder="e.g. Mini bagels" data-testid={`recipe-component-name-${i}`} className="col-span-6 h-10 rounded-xl border-black/10" />
          <Input type="number" step="any" min="0" value={c.amount ?? ""} onChange={(e) => set(i, "amount", e.target.value)} placeholder="Amt ?" data-testid={`recipe-component-amount-${i}`} className={`col-span-2 h-10 rounded-xl ${c.amount === "" || c.amount == null ? "border-brand-gold" : "border-black/10"}`} />
          <Input value={c.unit_label || ""} onChange={(e) => set(i, "unit_label", e.target.value)} placeholder="slices" data-testid={`recipe-component-unit-${i}`} className="col-span-3 h-10 rounded-xl border-black/10" />
          <button type="button" onClick={() => onChange(comps.filter((_, j) => j !== i))} data-testid={`recipe-component-remove-${i}`} className="col-span-1 p-2 rounded-full text-red-600 hover:bg-red-50" aria-label="Remove component"><Trash2 className="h-4 w-4" /></button>
        </div>
      ))}
      <button type="button" onClick={() => onChange([...comps, { name: "", amount: "", unit_label: "" }])} data-testid="recipe-add-component"
        className="w-full h-10 rounded-xl border border-dashed border-brand-charcoal/25 text-[11px] font-bold uppercase tracking-[0.1em] inline-flex items-center justify-center gap-1.5">
        <Plus className="h-3.5 w-3.5" /> Add checklist item
      </button>
    </div>
  );
};

export default ComponentsEditor;
